import { render } from "./DamagedbPage.vue?vue&type=template&id=58553ba4&ts=true"
import script from "./DamagedbPage.vue?vue&type=script&lang=ts"
export * from "./DamagedbPage.vue?vue&type=script&lang=ts"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__